/**
 * Structured Field Parameters
 *
 * @group Structured Field
 *
 * @beta
 */
export type SfParameters = Record<string, any>;
